/*
   ****** The below React component is developed by Your Company Name ******
   Please don't remove, replace, or edit this header information
   Component: <ForgotPassword.js>
   Description: This React component represents the "Forgot Password" page. It allows users to reset their passwords by entering their 
   email address and selecting their user type. The component handles both new and existing users, sends a password reset email, 
   and provides feedback to the user. The styling is done using MUI components.
   Dependencies: React, React Router, MUI components.
 */

   import React, { useState } from 'react';
   import { useNavigate } from 'react-router-dom';
   import Card from '@mui/material/Card';
   import CardContent from '@mui/material/CardContent';
   import '../css/ForgotPassword.css';
   import { API_ENDPOINTS } from '../Auth/apiConfig';
   
   const ForgotPassword = ({ loggedInUser }) => {
     const [email, setEmail] = useState('');
     const [isNewUser, setIsNewUser] = useState(false);
     const [isExistingUser, setIsExistingUser] = useState(false);
     const [username, setUsername] = useState('');
     const [formSubmitted, setFormSubmitted] = useState(false);
     const navigate = useNavigate();
   
     const handleNewUserChange = () => {
       setIsNewUser(!isNewUser);
       setIsExistingUser(false);
     };
   
     const handleExistingUserChange = () => {
       setIsExistingUser(!isExistingUser);
       setIsNewUser(false);
     };
   
     const handleGoToLogin = () => {
       navigate('/Login');
     };
   
     const handleSubmit = async (e) => {
       e.preventDefault();
       setFormSubmitted(true);
       if (!email) {
         alert('Please enter your email address.');
         return;
       }
       try {
         const response = await fetch(`${API_ENDPOINTS.forgotpassword}`, {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify({ email }),
         });
         if (!response.ok) {
           throw new Error(`HTTP error! Status: ${response.status}`);
         }
         const result = await response.json();
         if (result.success) {
           alert('Password reset email sent successfully.');
         } else {
           alert('Failed to send password reset email.');
         }
       } catch (error) {
         console.error('Error during fetch:', error);
         alert('An error occurred while sending the password reset email.');
       }
     };
   
     return (
       <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: '#EBEFF3' }}>
         <Card style={{ maxWidth: '510px', maxHeight: '80vh', borderRight: '5px solid red', borderBottom: '5px solid red' }}>
           <CardContent className="bg-lightblue rounded-10 shadow">
             <h1 className="text-center mb-4">Forgot Password</h1>
             <form onSubmit={handleSubmit}>
               <ul>
                 <li>Thanks for visiting the Vaculink 2.r Portal.</li>
                 <li>Please enter your username and email address to reset your password.</li>
                 <li>If you encounter any difficulties, please feel free to contact us at (
                   <a href="mailto:service@quavac.com">service@quavac.com</a>) or (
                   <a href="mailto:support.quavac@myaecs.com">support.quavac@myaecs.com</a>) for assistance.
                 </li>
               </ul>
               <div className="mb-3" style={{ maxWidth: '400px', display: 'flex', alignItems: 'center' }}>
                 <label htmlFor="email" className="form-label" style={{ marginRight: '10px' }}>
                   <span style={{ color: 'red' }}>*</span> Email address:
                 </label>
                 <input
                   type="email"
                   className="form-control"
                   id="email"
                   placeholder='Enter your email address'
                   value={email}
                   onChange={(e) => setEmail(e.target.value)}
                   required
                   style={{
                     flex: 1,
                     border: '1.3px dashed #007bff', // Dashed border style
                     borderRadius: '2px',
                     padding: '5px',
                     outline: 'none',
                   }}
                 />
               </div>
   
               {isExistingUser && (
                 <div className="mb-3">
                   <label htmlFor="username" className="form-label">
                     Username
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     id="username"
                     value={username}
                     onChange={(e) => setUsername(e.target.value)}
                     required
                   />
                 </div>
               )}
               {formSubmitted && !email && (
                 <div className="mb-3">
                   <span style={{ color: 'red' }}>Please enter your email address.</span>
                 </div>
               )}
               <div className="button-container">
                 <button type="submit" className="btn btn-primary reset-button">
                   Reset Password
                 </button>
                 <button
                   onClick={handleGoToLogin}
                   type='button'
                   className="go-back-button"
                 >
                   Go back to Login
                 </button>
               </div>
             </form>
           </CardContent>
         </Card>
       </div>
     );
   };
   
   export default ForgotPassword;   